module.exports = __webpack_public_path__ + "static/img/world_cate.93b8680.93b8680e.jpg";